import { Comment, ThumbUp, Reply, Facebook } from "@mui/icons-material";
import { Box, Divider, Typography } from "@mui/material";
// import { findAllByPlaceholderText } from "@testing-library/react";
import React from "react";
import { parseURL } from "../../../common";
import PostDateElement from "../element/PostDateElement";
import PostImageElement from "../element/PostImageElement";
import PostMetaElement from "../element/PostMetaElement";
import PostTextElement from "../element/PostTextElement";
import CommentIcon from '@mui/icons-material/Comment';

function FacebookCommentPostCard({post, padding, intent}){
    
    let text = post.post_text;
    text = parseURL(text);
    
    
    return <>

        <Box p={padding}>

        {
    post.fb_group_id && <>
            <Typography sx={{fontSize:"small", fontWeight:"bold", color:"#999999"}}>
                <>
                <a href={"http://facebook.com/groups/" + post.fb_group_id} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#999999' }}>{post.fb_group_name}</a>
                </>
            </Typography>
            </>
}            

            <Typography sx={{fontSize:"small", fontWeight:"bold", color:"#666666"}}>
                {/* {post.fb_group_name} */}
                <>
                <a href={"http://facebook.com/profile.php?id=" + post.user_id} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#666666' }}>{post.user_screenname}</a>
                </>
            </Typography>
        <Divider />
    
        </Box>

        <PostImageElement post={post} />

        <Box p={padding}>
            {/* THIS BREAKS THINGS */}
            <PostTextElement post={post} text={text} truncate={200} intent={intent} /> 
            <PostDateElement post={post} />
        </Box>
        <Divider />
        <Box p={padding} display="flex" alignItems={"center"} justifyContent="space-between">
            <Box display="flex" alignItems={"center"} mr={1}>
                <ThumbUp sx={{marginRight: 0.5, fontSize:14}} fontSize="small"/>
                <span style={{fontSize: 12}}>{post.fb_likes ?? 0}</span>

                <Comment sx={{ fontSize: 14, marginRight: 0.5, marginLeft: 2}} fontSize="small"/>
                <span style={{fontSize: 12}}>{post.fb_comments ?? 0}</span>

                <Reply sx={{ fontSize: 14, marginRight: 0.5, marginLeft: 2}} fontSize="small"/>
                <span style={{fontSize: 12}}>{post.fb_shares ?? 0}</span>
            </Box>
            <Box>
                <Facebook sx={{fontSize:20, color: '#4267B2', margin:0}}/>
                <CommentIcon sx={{fontSize:20, color: '#4267B2', margin:0, position:"relative", top:"2px"}}/>
            </Box>
        </Box>
        <Divider />
        <Box p={padding}>
            <PostMetaElement post={post} intent={intent} />
        </Box>
    </>
}
export default FacebookCommentPostCard;